import { render, staticRenderFns } from "./VvButton.vue?vue&type=template&id=1e46b0b4&scoped=true&"
import script from "./VvButton.vue?vue&type=script&lang=js&"
export * from "./VvButton.vue?vue&type=script&lang=js&"
import style0 from "./VvButton.vue?vue&type=style&index=0&id=1e46b0b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e46b0b4",
  null
  
)

export default component.exports